import Constants from 'js/Constants';

export const API_URL_PLACEHOLDER_PATTERN = /{[a-zA-Z]+\d+\.\w+}/g;

export const DEFAULT_ITERATION = {
  key: undefined,
  isPaginated: false,
  'iteration.type': 'paging.incrementing',
  'request.parallelism.count': 1,
  method: 'GET',
  'date.format': 'yyyy-MM-dd',
  'date.time.unit': 'dd',
};

export const ITERATION_TYPE_TO_FIELDS_MAP = {
  'paging.incrementing': [
    'param.id',
    'start.page.from',
    'end.page.to',
    'param.page.size',
    'page.expected.rows',
    'request.parallelism.count',
  ],
  'paging.incrementing.offset': [
    'param.offset',
    'start.offset.from',
    'end.offset.to',
    'param.page.size',
    'page.expected.rows',
  ],
  'paging.next.token': ['response.next.token.data.path', 'param.id', 'end.token.to'],
  'paging.next.url': ['response.next.url.data.path', 'end.url.to'],
  'link.header': ['link'],
  'response.id.number': [
    'param.id',
    'start.id.from',
    'end.id.to',
    'response.id.field.name',
    'param.id.inclusive',
  ],
  'response.id.string': ['param.id', 'start.id.from', 'end.id.to', 'response.id.field.name'],
  'graphql.page': ['graphql.page.name', 'graphql.page.start'],
  'graphql.cursor': [
    'graphql.cursor.name',
    'response.graphql.cursor.path',
    'graphql.cursor.template',
  ],
  'data.map.key.queue': ['map.id'],
  'async.poll': ['async.iteration.path', 'async.iteration.value'],
  'body.as.file': ['file.response.format'],
  'static.url': [],
};

export const HC_SOURCE_FIELD_NAMES_AND_OTHERS = [
  'start.cron',
  'advanced_templatized_api',
  'adaptive_flow',
  ...Constants.HC_SOURCE_FIELD_NAMES,
];
